export const _REGEX_FOR_EMAIL = '[A-Za-z0-9.]{3,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{3,})';
export const _REGEX_FOR_TEXT_WITH_SPACE = '[A-Za-z]{1}[A-Za-z ]*';
export const _REGEX_FOR_ANY_CHAR_WITH_SPACE = '[A-Za-z0-9]{1}[A-Za-z0-9 ]*';
export const _REGEX_FOR_ONLY_CHAR = '[A-Za-z ]*';
export const _REGEX_FOR_PASSWORD = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[_!@#\$%\^&\*])(?=.{8,12}$)/;
export const _REGEX_FOR_TELEPHONE = '[0-9]{3}-[0-9]{3}-[0-9]{4}'
export const _REGEX_FOR_ONLY_DIGITS = '[0-9]*'
